export default __webpack_public_path__ + "static/media/AxionColliderLogo.805cbed9.svg";